import { useCallback } from 'react';
import classNames from 'classnames';
import property from 'lodash.property';
import cellStyles from 'src/components/common/Grid/Cells/styles.module.scss';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { IGridRowProps } from './types';
import gridStyles from './styles.module.scss';

const GridRow = ({
  rowData,
  columns,
  className,
  noValueSymbol,
}: IGridRowProps) => {
  const { t } = useOTSTranslation('common');
  const extractValue = useCallback((row: any, key: string): React.ReactNode => {
    const getData = property(key);

    return getData(row) as React.ReactNode;
  }, [rowData, columns]);

  return (
    <tr className={classNames(gridStyles.row, className)}>
      {columns.map((column) => {
        const { cellRender, className: contentClassName } = column;

        if (cellRender) {
          return (
            <td key={`${rowData.resort?.uuid}-${column.dataKey}`} className={classNames(cellStyles.commonCell, cellStyles.commonRowCell, contentClassName)}>
              {cellRender(rowData)}
            </td>
          );
        }

        const { dataKey } = column;
        const value = (dataKey && extractValue(rowData, dataKey)) || noValueSymbol || t('common.dash');

        return (
          <td key={`${rowData.resort?.uuid}-${column.dataKey}`} className={classNames(cellStyles.commonCell, cellStyles.commonRowCell, contentClassName)}>
            <span className={classNames('h4', cellStyles.h4)}>
              {value}
            </span>
          </td>
        );
      })}
    </tr>
  );
};

export default GridRow;
